<template>
    <div class="contest-box-container selectable" @click="goToContest">
        <h3 class="contest-box-title">{{ name }}</h3>
        <p class="contest-box-description">{{ description }}</p>
        <p class="contest-box-stats"><strong>{{ submissions }}</strong> images submitted - <strong>{{ votes }}</strong> votes
            casted.</p>
        <div class="contest-box-dates">
            <p class="contest-box-date-box">{{ formatDateUS(start) }}</p>
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right"
                viewBox="0 0 16 16">
                <path fill-rule="evenodd"
                    d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
            </svg>
            <p class="contest-box-date-box">{{ formatDateUS(end) }}</p>
        </div>
    </div>
</template>

<script setup>
import { formatDateUS } from '@/util/dateUtil';
import { useRouter } from 'vue-router';

const router = useRouter();

const props = defineProps({
    id: Number,
    creator_id: Number,
    name: String,
    description: String,
    start: Date,
    end: Date,
    votes: Number,
    submissions: Number
})

function goToContest() {
    router.push(`/contests/${props.id}`)
}
</script>

<style scoped>
.contest-box-container {
    border: 1px solid lightgray;
    padding: 1rem;
    border-radius: 10px;
    width: 40%;
}

.contest-box-title {
    margin: 0;
}

.contest-box-stats {
    font-size: 1rem;
    font-weight: lighter;
    font-style: italic;
}

.contest-box-dates {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 1rem;
}

.contest-box-date-box {
    background-color: rgb(224, 224, 224);
    border-radius: 5px;
    padding: 5px;
}
</style>